import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthenticationService, TranslatePipe } from '@ascent/shared';

/**
 * Where Cardinal sends the user after signing out.
 *
 * It exists because nothing else in this application renders without a session: returning to any
 * other address starts a new sign-in, and being signed out would last exactly one redirect. This is
 * the only route outside the AuthGuard.
 *
 * Deliberately bare -- no navigation, no data, nothing that would need a token to render.
 */
@Component({
  selector: 'app-signed-out',
  templateUrl: './signed-out.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './signed-out.component.scss',
  imports: [TranslatePipe]
})
export class SignedOutComponent {

  constructor(
    private _authenticationService: AuthenticationService
  ) { }

  public signIn(): void {
    this._authenticationService.signInInteractively();
  }
}
